module.exports = __webpack_public_path__ + "static/media/ben-oshea@2x.bfdaf8a4.png";